<div
    [id]="id + '.' + filter.id"
    class="agpr-filterRange"
    [ngClass]="{'social': style === styleEnum.social}"
>
    <div
        class="agpr-filterRange-min"
    >
        <div
            class="agpr-filterRange-label"
        >
            <span>
                {{ 'Common.filter.range.minimum' | localize }}
            </span>
            <span *ngIf="filter.currency">&nbsp;({{ userCurrency }})</span>
            <span *ngIf="filter.percentType" class="agpr-filterRange-unit"> % </span>
            <span *ngIf="filter.fileType" class="agpr-filterRange-unit"> (KB) </span>
            <span *ngIf="!filter.percentType" class="agpr-filterRange-icons">
                <i *ngIf="filter.unitIcon" class="agpr-filterRange-unit" [ngClass]="filter.unitIcon"></i>
            </span>
        </div>
        <agpr-number-input
            [id]="id + '.' + filter.id + '.min'"
            class="agpr-filterRange-input"
            [ngClass]="{'social': style === styleEnum.social}"
            [min]="filter.min"
            [max]="maxValueForMin"
            [(ngModel)]="value.min"
            (ngModelChange)="update()"
            [forceMinValue]="false"
            (blur)="focusOutMin()"
            [ariaLabelledBy]="'Common.filter.range.minimum' | localize"
        >
        </agpr-number-input>
    </div>
    <div
        class="agpr-filterRange-max"
    >
        <div
            class="agpr-filterRange-label"
        >
            <span>
            {{ 'Common.filter.range.maximum' | localize }}
            </span>
            <span *ngIf="filter.currency">&nbsp;({{ userCurrency }})</span>
            <span *ngIf="filter.percentType" class="agpr-filterRange-unit"> % </span>
            <span *ngIf="filter.fileType" class="agpr-filterRange-unit"> (KB) </span>
            <span *ngIf="!filter.percentType" class="agpr-filterRange-icons">
                <i *ngIf="filter.unitIcon" class="agpr-filterRange-unit" [ngClass]="filter.unitIcon"></i>
            </span>
        </div>
        <agpr-number-input
            [id]="id + '.' + filter.id + '.max'"
            class="agpr-filterRange-input"
            [ngClass]="{'social': style === styleEnum.social}"
            [(ngModel)]="value.max"
            (ngModelChange)="update()"
            [min]="minValueForMax"
            [max]="filter.max"
            [forceMinValue]="false"
            (blur)="focusOutMax()"
            [ariaLabelledBy]="'Common.filter.range.minimum' | localize"
        ></agpr-number-input>
    </div>
</div>
